<template>
  <div class="clockRules">
    <OACard>
      <OAButton @click="addRule">添加规则</OAButton>
      <el-card shadow="hover" v-for="rule in data" :key="rule.id">
        <div slot="header">
          <el-row>
            <el-col :span="20">
              <el-tag v-for="(name,index) in rule.companyNames" :key="index">{{name}}</el-tag>
            </el-col>
            <el-col :span="4">
              <span class="pull-right">
                <OAButton @click="editRule(rule)" type="warning" size="mini">编辑</OAButton>
                <OAButton @click="removeRule(rule.id)" type="danger" size="mini">删除</OAButton>
              </span>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="8">
            <div>上午上下班规则：{{rule.timeTowork}} - {{rule.endTowork}}</div>
            <div>上午迟到规则：上班后 {{rule.laterTowork}} 分钟</div>
            <div>上午早退规则：上班前 {{rule.earlyTowork}} 分钟</div>
          </el-col>
          <el-col :span="8">
            <div>下午上下班规则：{{rule.timeOffduty}} - {{rule.endOffduty}}</div>
            <div>下午迟到规则：上班后 {{rule.laterOffduty}} 分钟</div>
            <div>下午早退规则：上班前 {{rule.earlyOffduty}} 分钟</div>
          </el-col>
          <el-col :span="8">
            <div>打卡时间限制：凌晨 {{rule.timeLimit}} 点以后可上班打卡</div>
          </el-col>
        </el-row>
      </el-card>
    </OACard>
    <OAModalForm
      :title="title"
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      labelWidth="150px"
      @on-cancel="dialogVisible = false"
    >
      <div class="addTips">小贴士："缺勤"状态无需手工添加，系统默认无状态时间段为缺勤。</div>
    </OAModalForm>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import checkApi from "@/services/check.js";
import { getValue, resFilter, setValue, clearValue } from "@/common/util.js";
import formComponent from "@/components/formComponents/form-component";
import OAModalForm from "@/components/OAModalForm/OAModalForm";
import { validNum } from "@/common/valid.js";
import { num } from "@/common/reg.js";

export default {
  name: "clockRules",
  components: { formComponent, OAModalForm, OACard },
  data() {
    let validRangeNum = (rule, value, callback) => {
      if (value != "" && new RegExp(num).test(value)) {
        if (value > 8 || value < 0) {
          callback(new Error("请输入0-8之间的数字"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入数字"));
      }
    };
    return {
      options: {
        border: true,
        stripe: true,
        size: "medium"
      },
      title: "",
      loading: false,
      dialogVisible: false,
      formData: {
        companyIds: {
          formType: "a-select",
          label: "应用公司：",
          value: [],
          api: "getCompany",
          props: {
            label: "companyName",
            value: "id"
          },
          multiple: true,
          placeholder: "请选择所在公司",
          rules: [
            {
              required: true,
              message: "请选择所在公司"
            }
          ]
        },
        toworkBetweenTime: {
          formType: "a-time-picker",
          label: "上午上下班规则：",
          value: ["00:00:00", "00:00:00"],
          placeholder: "请选择上午上下班规则",
          rules: [
            {
              required: true,
              message: "请选择上午上下班规则"
            }
          ]
        },
        laterTowork: {
          formType: "a-input-slot",
          label: "上午迟到规则：",
          value: undefined,
          placeholder: "请输入上午迟到规则",
          prepend: "上班后",
          append: "分钟",
          rules: [
            {
              required: true,
              message: "请输入上午迟到规则"
            },
            validNum()
          ]
        },
        earlyTowork: {
          formType: "a-input-slot",
          label: "上午早退规则：",
          value: undefined,
          placeholder: "请输入上午早退规则",
          prepend: "下班前",
          append: "分钟",
          rules: [
            {
              required: true,
              message: "请输入上午早退规则"
            },
            validNum()
          ]
        },
        offdutyBetweenTime: {
          formType: "a-time-picker",
          label: "下午上下班规则：",
          value: ["00:00:00", "00:00:00"],
          placeholder: "请选择下午上下班规则",
          rules: [
            {
              required: true,
              message: "请选择下午上下班规则"
            }
          ]
        },
        laterOffduty: {
          formType: "a-input-slot",
          label: "下午迟到规则：",
          value: undefined,
          placeholder: "请输入下午迟到规则",
          prepend: "上班后",
          append: "分钟",
          rules: [
            {
              required: true,
              message: "请输入下午迟到规则"
            },
            validNum()
          ]
        },
        earlyOffduty: {
          formType: "a-input-slot",
          label: "下午早退规则：",
          value: undefined,
          placeholder: "请输入下午早退规则",
          prepend: "下班前",
          append: "分钟",
          rules: [
            {
              required: true,
              message: "请输入下午早退规则",
              trigger: "blur"
            },
            validNum()
          ]
        },
        timeLimit: {
          formType: "a-input-slot",
          label: "打卡时间限制：",
          value: undefined,
          prepend: "凌晨",
          append: "点以后",
          placeholder: "请输入打卡时间限制",
          rules: [
            { validator: validRangeNum, trigger: "blur", required: true }
          ],
          showToolTip: true,
          content: "设置次日凌晨可打上班卡时间（0点-8点）"
        }
      },
      data: []
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async handleSearch() {
      this.loading = true;
      let res = await checkApi.getRules();
      this.data = res.data.data;
      this.loading = false;
    },
    addRule() {
      this.dialogVisible = true;
      clearValue(this.formData);
      this.formData.companyIds.value = [];
      this.formData.toworkBetweenTime.value = ["00:00:00", "00:00:00"];
      this.formData.offdutyBetweenTime.value = ["00:00:00", "00:00:00"];
      this.title = "添加规则";
    },
    editRule(value) {
      setValue(value, this.formData);
      this.formData.toworkBetweenTime.value = [
        value.timeTowork,
        value.endTowork
      ];
      this.formData.offdutyBetweenTime.value = [
        value.timeOffduty,
        value.endOffduty
      ];
      this.dialogVisible = true;
      this.title = "编辑规则";
      this.id = value.id;
    },
    removeRule(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await checkApi.deleteRules({ id: id });
          resFilter(res, this.handleSearch());
        })
        .catch(() => {});
    },
    async submit(val) {
      let res;
      if (this.id) {
        val["id"] = this.id;
        res = await checkApi.editRules(val);
      } else {
        res = await checkApi.addRules(val);
      }
      resFilter(res, this.handleSearch());
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss">
.clockRules {
  .el-card {
    margin-top: 10px;
    .el-card__header {
      padding: 10px;
      line-height: 30px;
      .el-tag {
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }
    .el-card__body {
      line-height: 30px;
    }
  }
  .el-select,
  .el-range-editor {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/personnel/clockRules.vue